import React, { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import { makeStyles } from '@material-ui/core';

import { Modal, ModalContent, ModalFooter } from 'Components/Modal';
import { useClassroomInterruption, useComponentSize } from 'Util/Hooks';

import useShowLiveCodingWarningModal from './useShowLiveCodingWarningModal';

const dialogStyles = makeStyles({
  root: ({ breakpoints, transBlack }) => ({
    // Override MUI dialog root
    backgroundColor: 'transparent',
    '& .MuiBackdrop-root': {
      backgroundColor: `${transBlack}`,
    },
    [`@media screen and (min-width: ${breakpoints[1]})`]: {
      display: 'none',
    },
  }),
});

const LiveCodingModal = () => {
  const { t } = useTranslation('classroom');
  const { breakpoints, _breakpoints, colors } = useTheme();
  const dialogClasses = dialogStyles({ breakpoints, transBlack: colors.blacks[10] });
  const { width: screenWidth } = useComponentSize({ current: document.getElementById('app') });

  const {
    isInterrupting,
    activateInterruption,
    deactivateInterruption,
    courseData: { courseCode },
  } = useClassroomInterruption();
  const [shouldShowLiveCodingWarningModal, markLiveCodingWarningShown] =
    useShowLiveCodingWarningModal({
      courseCode,
    });

  useEffect(() => {
    if (screenWidth >= _breakpoints[1]) {
      deactivateInterruption();
    } else if (shouldShowLiveCodingWarningModal) {
      activateInterruption();
    }
  }, [screenWidth]);

  return (
    <Modal
      contents={
        <ModalContent
          imageUrl={'/assets/images/classroom/previewModal.svg'}
          title={t('LIVE_CODING.TITLE')}
          description={
            <Trans
              defaults={t('LIVE_CODING.DESCRIPTION')}
              components={[<br key="description" />]}
            />
          }
        />
      }
      footer={
        <ModalFooter
          primaryButtonLabel={t('LIVE_CODING.CONFIRM_BUTTON')}
          onPrimaryButtonClick={() => {
            deactivateInterruption();
            markLiveCodingWarningShown();
          }}
          justifyContent={'center'}
          mt={7}
        />
      }
      muiProps={{
        isActive: isInterrupting,
        muiStyles: dialogClasses,
      }}
    />
  );
};

export default LiveCodingModal;
